module.exports = __webpack_public_path__ + "static/media/placeholder.8e785eb1.png";